import { render, staticRenderFns } from "./OpenCard02.vue?vue&type=template&id=ed99ed44&"
import script from "./OpenCard02.vue?vue&type=script&lang=js&"
export * from "./OpenCard02.vue?vue&type=script&lang=js&"
import style0 from "./OpenCard02.vue?vue&type=style&index=0&id=ed99ed44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports